import { ChevronRightIcon } from '@heroicons/react/24/outline'

import { useProjectList } from '@/api/models/main'
import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { ButtonSkeleton } from '@/components/shared/skeleton'

type Props = {
  className?: string
  handleProjectSelectClick: () => void
  selectedProjectName: string
  isLoading: boolean
}

export const ProjectSelectionButton = ({
  className,
  handleProjectSelectClick,
  selectedProjectName,
  isLoading
}: Props) => {
  const { data: projectList = [] } = useProjectList()

  const isProjectOne = projectList.length === 1

  if (isLoading) {
    return <ButtonSkeleton height={44} />
  }

  return (
    <AppButton
      filledWith="icon-append"
      size="small"
      variant="backless"
      className={cn(
        '!border-0 !bg-white xs:hidden',
        isProjectOne && '!cursor-default',
        className
      )}
      onClick={() => !isProjectOne && handleProjectSelectClick()}
    >
      <span data-testid="selected-project-name">{selectedProjectName}</span>
      {!isProjectOne && <ChevronRightIcon className="h-16 w-16" />}
    </AppButton>
  )
}
